import createRestApiClient from "../../utility/createRestApiClient";
import {
  LAMBDATEST_CONCURRENCY_DATA_LOADING,
  LAMBDATEST_CONCURRENCY_DATA_SUCCESS,
  LAMBDATEST_CONCURRENCY_DATA_FAILED,
  LAMBDATEST_CONCURRENCY_DATA_SILENT_LOADING
} from "../actionTypeConstants/LambdaTestConcurrencyConstants";
import { getCookieData } from "../../utility/cookieHandler/handler";
import { getApiBaseUrl } from "../../utility/utilityFunctions";

export function fetchConcurrencyDetails({
  sseEnabled = false,
  automationApiHost = ""
}) {
  let cookieName = process.env.REACT_APP_COOKIE_NAME;
  let access_token = getCookieData(cookieName);
  if (!access_token) {
    window.location.href =
      process.env.REACT_APP_LOGIN_URL || window?._env_?.REACT_APP_LOGIN_URL;
  }
  const HOST = automationApiHost || getApiBaseUrl();

  const apiClient = createRestApiClient().withConfig({
    baseURL: HOST
  }).client;
  let types = [
    LAMBDATEST_CONCURRENCY_DATA_LOADING,
    LAMBDATEST_CONCURRENCY_DATA_SUCCESS,
    LAMBDATEST_CONCURRENCY_DATA_FAILED
  ];
  if (sseEnabled) {
    types = [
      LAMBDATEST_CONCURRENCY_DATA_SILENT_LOADING,
      LAMBDATEST_CONCURRENCY_DATA_SUCCESS,
      LAMBDATEST_CONCURRENCY_DATA_FAILED
    ];
  }
  const endPoint = `${HOST}/api/v2/concurrency`;
  return {
    types: types,
    promise: () =>
      apiClient.get(`${endPoint}`, {
        headers: {
          Authorization: `Bearer ${access_token}`
        }
      })
  };
}

export function SSE_fetchConcurrencyDetails() {
  let cookieName = process.env.REACT_APP_COOKIE_NAME;
  let access_token = getCookieData(cookieName);
  if (!access_token) {
    window.location.href =
      process.env.REACT_APP_LOGIN_URL || window?._env_?.REACT_APP_LOGIN_URL;
  }
  const HOST = getApiBaseUrl();

  const apiClient = createRestApiClient().withConfig({
    baseURL: HOST
  }).client;
  let types = [
    LAMBDATEST_CONCURRENCY_DATA_SILENT_LOADING,
    LAMBDATEST_CONCURRENCY_DATA_SUCCESS,
    LAMBDATEST_CONCURRENCY_DATA_FAILED
  ];

  const endPoint = `${HOST}/api/v2/concurrency`;
  return {
    types: types,
    promise: () =>
      apiClient.get(`${endPoint}`, {
        headers: {
          Authorization: `Bearer ${access_token}`
        }
      })
  };
}
